import { getStandorte } from '../../../../helpers/getStandorte';
import { getStyle } from './getStyle';
import { getThgText } from '../../../../main/functions/thg/getThgText';
import { getVeranstaltungen } from '../../../../helpers/getVeranstaltungen';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { Table } from '../../vsme/report/Table';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export interface ModuleProps {
    data: any;
    isPdf?: boolean;
    jahr: number;
    standort?: number;
    getPageNum?: (key: string, page: number, level: number) => void;
}

export class Module extends React.Component<ModuleProps, {}> {

    constructor(props: any) {
        super(props);
        this.init();
    }

    private flag: any;
    private data: any;
    private placeholder: any;
    private prefix: any;
    private Table: any;

    init(): void {
        const { data, jahr, standort } = this.props;
        this.Table = new Table(this.props.data, { jahr, standort_tid: standort });
        this.data = ((((data || {})[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).thg || {})[standort || 'all'] || {};
        this.flag = this.data.flag || {};
        this.placeholder = this.data.placeholder || {};
        this.prefix = {};
        // console.info(jahr, standort, this.data, (((data || {})[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {}).thg);
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.standort !== prevProps.standort || this.props.jahr !== prevProps.jahr) {
            this.init();
        }
    }

    render(): JSX.Element {
        return <>
            {this.renderHeading('2. Rahmenbedingungen', 1)}
            {this.renderMotivationZielsetzung()}
            {this.renderUnternehmenTaetigkeitsprofil()}
            {this.renderUmweltKlimazertifizierungen()}
            {this.renderKonsolidierungsansatzTochtergesellschaften()}
            {this.renderSystemgrenzenTreibhausgasbilanz()}
        </>;
    }

    renderAbsatz(keys: string[]): JSX.Element {
        const { data, jahr, standort } = this.props;
        const isPdf: boolean = !!this.props.isPdf;

        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    {keys.map((key: string) => getThgText(key, data, jahr, standort) || '').join(' ')}
                </WpdfText>
            </WpdfView>
        );
    }

    renderHeading(name: string, level: number): JSX.Element {
        const { getPageNum } = this.props;
        const isPdf: boolean = !!this.props.isPdf;
        const prefix: any = this.prefix || {};
        const style: React.CSSProperties = level === 1 ? getStyle('h1', isPdf) : level === 2 ? getStyle('h2', isPdf) : {};

        if (!prefix[name] && level === 2) {
            prefix[name] = `2.${Object.keys(prefix).length + 1} `;
        }
        const pageName: string = `${prefix[name] || ''}${name || ''}`;

        return (
            <WpdfView style={style} pdf={isPdf}>
                <WpdfText
                    pdf={isPdf}
                    getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(pageName, pageNumber, level)}
                >
                    {pageName}
                </WpdfText>
            </WpdfView>
        );
    }

    renderKonsolidierungsansatzTochtergesellschaften(): JSX.Element {
        const elements: JSX.Element[] = [];
        const data: any = this.data.konsolidierungsansatz_tochtergesellschaften || {};
        const isPdf: boolean = !!this.props.isPdf;
        const konsolidierungsansatz: any = data.konsolidierungsansatz;
        const tochtergesellschaften: any[] = data.tochtergesellschaften || [];

        (this.flag.hasTochtergesellschaften ? tochtergesellschaften : []).forEach((item: any, index: number) => {
            elements.push(
                <WpdfView
                    key={`tochtergesellschaften-${index}`}
                    style={{ ...getStyle('italic', isPdf), display: 'flex', flexDirection: 'column' }}
                    pdf={isPdf}
                >
                    <WpdfView
                        style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', ...(isPdf && { width: '90%' }) }}
                        pdf={isPdf}
                    >
                        <WpdfText style={getStyle('list_number')} pdf={isPdf}>{index + 1}.</WpdfText>
                        <WpdfText pdf={isPdf}>{item.name}</WpdfText>
                    </WpdfView>
                </WpdfView>
            );
        });

        return <>
            {this.renderHeading('Konsolidierungsansatz & Tochtergesellschaften', 2)}
            {this.flag.hasTochtergesellschaften
                ? this.renderAbsatz(['konsolidierungsansatz_tochtergesellschaften_absatz1'])
                : this.renderAbsatz(['konsolidierungsansatz_tochtergesellschaften_absatz1_v2'])
            }
            {this.flag.hasTochtergesellschaften && <>
                {tochtergesellschaften.length
                    ? <WpdfView style={{ ...getStyle('div'), ...getStyle('list') }} pdf={isPdf}>{elements}</WpdfView>
                    : 'keine Angabe'
                }
            </>}
            {this.renderText('Das Unternehmen hat folgenden Konsolidierungsansatz gewählt:')}
            <WpdfView style={getStyle('italic', isPdf)} pdf={isPdf}>
                {this.renderText(konsolidierungsansatz || 'keine Angabe')}
            </WpdfView>
        </>;
    }

    renderMotivationZielsetzung(): JSX.Element {
        const motivation: any = (this.data.motivation_zielsetzung || {}).motivation;

        return typeof motivation !== 'undefined' && motivation !== null
            ? <>{this.renderHeading('Motivation und Zielsetzung', 2)}{this.renderText(motivation)}</> : null;
    }

    renderSystemgrenzenTreibhausgasbilanz(): JSX.Element {
        const elements: JSX.Element[] = [];
        const isPdf: boolean = !!this.props.isPdf;
        const scope3: any = (this.data.systemgrenzen_treibhausgasbilanz || {}).scope3;
        const standorte: any[] = [...(getStandorte(this.props.data) || []), ...(getVeranstaltungen(this.props.data) || [])];
        const systemgrenzen: any = (this.data.systemgrenzen_treibhausgasbilanz || {}).systemgrenzen;
        const addElement = (item: any, index: number, standort?: string) => {
            elements.push(
                <WpdfView key={`scope3-${index}-${standort}`} style={{ display: 'flex', flexDirection: 'column' }} pdf={isPdf} nowrap>
                    {!!standort && !index &&
                        <WpdfView style={{ ...getStyle('h2', isPdf), marginLeft: 0, marginBottom: '10pt', marginTop: '10pt' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{standort}</WpdfText>
                        </WpdfView>
                    }
                    <WpdfView
                        style={{
                            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'baseline', marginTop: index ? '5pt' : 0,
                            ...(isPdf && { width: '90%' })
                        }}
                        pdf={isPdf}
                    >
                        <WpdfText style={getStyle('bold', isPdf)} pdf={isPdf}>
                            {item.name}:
                        </WpdfText>
                        <WpdfText style={{ marginLeft: '5pt' }} pdf={isPdf}>{item.hinweis || 'keine Angabe'}</WpdfText>
                    </WpdfView>
                </WpdfView>
            );
        };

        if (this.props.standort) {
            (this.flag.hasScope3 ? scope3 || [] : []).forEach((item: any, index: number) => {
                addElement(item, index);
            });
        } else {
            standorte.forEach((standort: any) => {
                ((scope3 || {})[standort.tid] || []).forEach((item: any, index: number) => {
                    addElement(item, index, standort.name);
                });
            });
        }

        return <>
            {this.renderHeading('Systemgrenzen der Treibhausgasbilanz', 2)}
            {typeof systemgrenzen !== 'undefined' && systemgrenzen !== null
                ? this.renderText(systemgrenzen)
                : this.renderText('keine Angabe')
            }
            {this.flag.hasScope3
                ? this.renderAbsatz(['systemgrenzen_treibhausgasbilanz_absatz1'])
                : this.renderAbsatz(['systemgrenzen_treibhausgasbilanz_absatz1_v2'])
            }
            {this.flag.hasScope3 && !!elements.length && <>
                {this.renderAbsatz(['systemgrenzen_treibhausgasbilanz_absatz2'])}
                <WpdfView style={{ ...getStyle('div'), ...getStyle('list') }} pdf={isPdf}>{elements}</WpdfView>
            </>}
            {this.renderAbsatz(['systemgrenzen_treibhausgasbilanz_absatz3'])}
        </>;
    }

    renderText(text: string): JSX.Element {
        const isPdf: boolean = !!this.props.isPdf;
        const chunks: string[] = (text || '').toString().split('\n');

        return (
            <WpdfView style={getStyle('div')} pdf={isPdf}>
                {chunks.map((chunk: string, index: number) =>
                    <WpdfView key={`text-${index}`} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{chunk.replace('−', '–') || '\u00a0\n'}</WpdfText>
                    </WpdfView>
                )}
            </WpdfView>
        );
    }

    renderUnternehmenTaetigkeitsprofil(): JSX.Element {
        const vorstellung: any = (this.data.unternehmen_taetigkeitsprofil || {}).vorstellung;

        return typeof vorstellung !== 'undefined' && vorstellung !== null
            ? <>{this.renderHeading('Unternehmen und Tätigkeitsprofil', 2)}{this.renderText(vorstellung)}</> : null;
    }

    renderUmweltKlimazertifizierungen(): JSX.Element {
        const umweltzertifizierungen: any = (this.data.umwelt_klimazertifizierungen || {}).umweltzertifizierungen;

        return typeof umweltzertifizierungen !== 'undefined' && umweltzertifizierungen !== null
            ? <>{this.renderHeading('Umwelt- und Klimazertifizierungen', 2)}{this.renderText(umweltzertifizierungen)}</> : null;
    }
}
